import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
@Injectable({
  providedIn: 'root'
})
export class CallApiService {

  constructor(
    private http: HttpClient,
    private router: Router
  ) { }

  _postAPI(url: string, params?, headers?) {
    return new Promise((resolve, reject) => {
      this.http.post(`${environment.apiUrl}` + url, params, headers)
        .subscribe(res => {
          if (res['status'] === 'success') {
            resolve(res)
          } else {
            if (res['response_code'] && res['response_code'] == 401) {
              Swal.fire({
                icon: 'info',
                title: 'Alert!',
                text: res['message'],
              }).then(result => {
                localStorage.removeItem('currentUser')
                this.router.navigate(['authentication/admin-signin']).then(() => {
                  window.location.reload();
                });
              })
              return
            }
            reject(res)
          }
        })
    })
  }
  _postAPI1(url: string, params?, headers?) {
    return new Promise((resolve, reject) => {
      this.http.post(`${environment.apiUrl}` + url, params, headers)
        .subscribe(res => {
          if (res['status'] === 'success') {
            resolve(res)
          } else {
            if (res['status'] && res['status'] == 'failed') {
              Swal.fire({
                icon: 'info',
                title: 'Alert!',
                text: res['message'],
              }).then(result => {
                // localStorage.removeItem('currentUser')
                this.router.navigate(['/patient/dashboard'])
                // .then(() => {
                // window.location.reload();
                // });
              })
              return
            }
            reject(res)
          }
        })
    })
  }
}
